export default __webpack_public_path__ + "static/media/placeholder_dummy2016-moebelbauer01-mobile-de.70037c55.png";